import React from 'react';
import {CurrencyFormat} from '../../utils';

const AccessoryCardWithButton = ({accessory, onClickDetail, onClickAdd}) => (
    <div className="accessory-card">
        <div className="accessory-card-detail" onClick={() => onClickDetail(accessory)}>
            {accessory.image && <img src={accessory.image.url} alt={accessory.image.alt} />}
            {accessory.price && <div className="price">{CurrencyFormat(accessory.price)}</div>}
            <p>{accessory.name}</p>
        </div>
        <button className={"btn " + (accessory.is_added ? "outline-red" : "outline-black")} onClick={() => onClickAdd(accessory)}>{accessory.is_added ? "- Quitar" : "Añadir"}</button>
    </div>
)

export default AccessoryCardWithButton;